import React from "react";
import { GradientDropdown } from "./ddStyles";

const DropDownBox = (props) => {
    return <GradientDropdown {...props}>{props.children}</GradientDropdown>;
};

export default DropDownBox;
